export enum ChatEvents {
    CONNECT = 'chat@connect',
    DISCONNECT = 'chat@disconnect',
    ERROR = 'chat@error',
    RETRY = 'chat@retry',
    MESSAGE = 'chat@message',

    // Response based messages
    NEW_MESSAGE = 'chat@new_message',
    TYPING_MESSAGE = 'chat@user_typing',
    UPDATED_MESSAGE = 'chat@message_updated',
}
